import {
  useHpApiInteractionsV3Handler_add,
  useHpApiInteractionsV3Handler_remove,
} from '@zg-rentals/ts-hotpads-api-client-react-query';
import { USER_LISTINGS_TAG } from './queryTags';

/**
 * Record a listing interaction (favorite/hide/view) via the v3 interactions endpoint.
 * Transport (CSRF header, envelope-error rejection) comes from the client registered
 * by configureHotpadsApiV3Client at bootstrap.
 * The USER_LISTINGS_TAG invalidation is what refreshes the favorites/hidden/history
 * lists after a write — it pairs by string with meta.tags on useUserListings.
 */
export const useAddUserInteraction = () =>
  useHpApiInteractionsV3Handler_add({
    meta: {
      invalidates: [USER_LISTINGS_TAG],
      context: {
        api: 'hotpads-api',
        details: 'add user interaction v3',
      },
    },
  });

export const useRemoveUserInteraction = () =>
  useHpApiInteractionsV3Handler_remove({
    meta: {
      invalidates: [USER_LISTINGS_TAG],
      context: {
        api: 'hotpads-api',
        details: 'remove user interaction v3',
      },
    },
  });
